import classes from "./tooltip.module.scss";
import icon from "../Assets/Img/Src/Svg/tooltip.svg";

function Tooltip(props) {
  return (
     <span className={classes.Tooltip + " " + (props.customClassToltip || "" )} >  
      <img src={icon} alt=""/>
        <span className={classes.Body}>
          <span className={classes.Text + " " + (props.customClass || "")}>{props.text }</span>
        </span>
    </span>
  )
}


export default Tooltip